import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PhoneInputLib from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import 'react-phone-number-input/style.css';
import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

const SUPPORTED_COUNTRIES = ['SN', 'ML', 'CI', 'NE'];

const PhoneInput = ({
    value = '',
    onChange,
    name,
    placeholder,
    defaultCountry = 'SN',
    required = false,
    className = '',
}) => {
    const { t } = useTranslation();
    const resolvedPlaceholder = placeholder ?? t('phoneInput.placeholder');
    const phoneNumber = useMemo(() => parsePhoneNumberFromString(value || ''), [value]);
    const isValid = !value || isValidPhoneNumber(value);
    const national = phoneNumber ? phoneNumber.formatNational() : '';
    const international = phoneNumber ? phoneNumber.formatInternational() : '';
    const e164 = phoneNumber ? phoneNumber.number : (value || '');

    const handleChange = (nextValue) => {
        if (typeof onChange === 'function') {
            onChange(nextValue || '');
        }
    };

    return (
        <div className={`w-full ${className}`.trim()}>
            <PhoneInputLib
                value={value || undefined}
                onChange={handleChange}
                countries={SUPPORTED_COUNTRIES}
                defaultCountry={defaultCountry}
                flags={flags}
                international={false}
                withCountryCallingCode={false}
                smartCaret
                name={name}
                placeholder={resolvedPlaceholder}
                required={required}
                className="phone-input-shell"
            />

            {/* <div className={`mt-1 text-xs ${isValid ? 'text-gray-500' : 'text-red-500'}`}>
                {value ? (
                    <>
                        {international ? <span>{international}</span> : null}
                        {international && national ? <span className="mx-2">•</span> : null}
                        {national ? <span>{national}</span> : null}
                        {(international || national) && e164 ? <span className="mx-2">•</span> : null}
                        {e164 ? <span>{e164}</span> : null}
                    </>
                ) : (
                    <span>Exemple: sélectionnez un pays puis saisissez le numéro</span>
                )}
            </div> */}
        </div>
    );
};

export default PhoneInput;
